import styled from 'styled-components'
// import ResizableBox from 'react-resizable/build/ResizableBox'

import { Select } from '../../../../../../../components/forms'
import Button from '../../../../../../../components/Button'

export const StyledSelect = styled(Select)`
	width: 200px;
 	div {
		cursor: pointer;
	}
	
	.Select__control {
		background: none!important;
		border-top-right-radius: 3px!important;
		border-bottom-right-radius: 3px!important;
		border-top-left-radius: 0!important;
		border-bottom-left-radius: 0!important;

	}
	.Select__indicators{
		display: none!important;
	}

`

export const StyledColorPicker = styled.div`
	height: 38px;
	border-left: 1px solid rgb(90, 90, 90, 0.1);
 	div:first-child {
		height: 38px;
		border: unset !important;
		border-top-right-radius: 3px!important;
		border-bottom-right-radius: 3px!important;
		border-top-left-radius: 0!important;
		border-bottom-left-radius: 0!important;
	}
`

export const StyledDnDContentSide = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
`

export const StyledDnDContainer = styled.div`
	width: 100%;
	/* height: 1030px; */
	border: 2px solid white;
	position: relative;
	overflow: auto;
	background: ${({ color }) => color || 'unset'};
`

export const StyledSelectContainer = styled.div`
	background: #ffffff;
	display: flex;
	align-items: center;
	box-shadow: 0 2px 2px 0 rgb(90, 90, 90, 0);
	margin-right: 26px;
`

export const StyledIconItem = styled.div`
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 2px 0 rgb(90, 90, 90, 0.1);
	border-radius: 3px 0 0 3px;
	width: 37px;
	height: 37px;
`
